module.exports = __webpack_public_path__ + "static/ilustracao-demo-resultados-3289c0afad4cb5c6c6a2cccb8d067931.svg";